export interface IMessage {
  createdAt: string;
  createdBy: string;
  frId: number;
  id: number;
  roomId: number;
  text: string;
  to: null | string;
  type: MessageType;
  updatedAt: string;
  updatedBy: string;
  creator: { firstName: string; lastName: string }
}

export interface IMessagesResponse {
  result: IMessage[];
  total: number
}

export interface IParticipant {
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
  id: string;
  userId: number;
  workerId: string | null;
  employeeId: string | null;
  frId: number;
  firstName: string;
  lastName: string;
  email: string;
  hireDate: string;
  terminationDate: string | null;
  mobileAccess: string | null;
  addressLine1: string;
  addressLine2: string | null;
  city: string;
  state: string;
  ZIP: string;
  homePhone: string | null;
  workPhone: string;
  emergencyContact: string | null;
  emergencyContactName: string | null;
  dlStateN: string | null;
  birthDate: string;
  payRate: number;
  overTimeRate: number;
  supervisorAlerts: string | null;
  accountName: string;
  routingNumber: string;
  accountNumber: string;
  notes: string | null;
  role: string;
  ssn: string;
  desiredHoursPerWeek: string | null;
  pdfAttachmentsArr: string;
  otherDocumentsArr: string;
  status: string;
  isDeleted: boolean;
}

export interface IGroupData {
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
  id: number;
  frId: number;
  name: string;
  participants: IParticipant[];
  lastMessage: LastMessage;
  type: RoomTypes;
  hasSeen: boolean
}

interface LastMessage {
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
  id: number;
  frId: number;
  roomId: number;
  to: string | null;
  text: string;
  type: MessageType;
  creator: {
    firstName: string;
    lastName: string;
  }
}

export enum RoomTypes {
  Direct = 'DIRECT',
  Group = 'GROUP',
}

export enum MessageType {
  File = 'FILE',
  Message = 'MESSAGE',
}